import moment from "moment";
import {
  isModuleActive,
  RIGHTS_STATUS_NOT_REQUIRED
} from "../constants/rights-constants";

/**
 * ¿Se deshabilita la descarga del ORIGINAL por las fechas de derechos?
 *
 * Nunca afecta a la versión optimizada: es lo que queda para descargar
 * cuando el original se bloquea.
 *
 * - Con el módulo: la regla de siempre, sin cambios. Estaba copiada en
 *   CollectionMiddleView (dos veces) y en DownloadModal; ahora vive acá.
 *   Bloquea lo vencido y también lo que todavía no empieza.
 * - Sin el módulo (DES-216, definido por Ricardo): SÓLO lo vencido. Lo que
 *   no tiene período definido se descarga, y lo que empieza en el futuro
 *   también. "No requiere derechos" nunca vence.
 *
 * Las fechas se comparan como día calendario: dueDate se guarda como la
 * medianoche UTC del día elegido, por eso se lee con .utc().
 */
export const isOriginalDownloadBlocked = (asset, modules) => {
  if (!asset || !asset.metadata) return false;

  const { createdDate, dueDate, rightsStatus } = asset.metadata;
  const today = moment().format("YYYY-MM-DD");
  const dayOf = date => moment(date).utc().format("YYYY-MM-DD");

  if (!isModuleActive(modules, "useRights")) {
    if (!dueDate || rightsStatus === RIGHTS_STATUS_NOT_REQUIRED) return false;
    return today > dayOf(dueDate);
  }

  if (asset.rightsState === "expired") return true;

  const hasCreatedDate = createdDate !== null && createdDate !== "";
  if (today > dayOf(dueDate) && hasCreatedDate) return true;
  return dayOf(createdDate) > today && today < dayOf(dueDate) && hasCreatedDate;
};

/**
 * ¿La descarga de este asset está bloqueada por derechos vencidos?
 *
 * Los dos flags se leen con isModuleActive, que aplica el mismo default que
 * MODULE_DEFAULTS en bunkey.objects cuando la clave todavía no está en la
 * cuenta. Antes se usaba un `.some()` pelado: para blockDownloadOnExpiredRights
 * —encendido por defecto, porque el bloqueo ya vive en producción— eso daba
 * false y el front habilitaba una descarga que el backend después rechazaba.
 */
export const isRightsDownloadBlocked = (asset, modules) => {
  if (!asset || asset.type === "folder" || asset.type === "bunker") return false;

  // canDownload viene del endpoint de detalle de derechos, que es la fuente
  // autoritativa. Cuando está, manda.
  if (asset.canDownload === false) return true;

  const useRightsActive = isModuleActive(modules, "useRights");
  const blockExpiredActive = isModuleActive(
    modules,
    "blockDownloadOnExpiredRights"
  );

  return useRightsActive && blockExpiredActive && asset.rightsState === "expired";
};

/**
 * Respuesta de /downloads/:client/dowload/multiple (KAN-52).
 *
 * Con `withExcluded: true` el backend responde { files, excluded }: lo que se
 * descarga y lo que queda fuera por derechos, con nombre y ruta. Sin el flag,
 * o con un backend anterior al cambio, responde la lista sola. Se aceptan las
 * dos formas para que el front pueda salir antes o después que bunkey.objects.
 */
export const splitDownloadList = data => {
  if (Array.isArray(data)) return { files: data, excluded: [] };
  return {
    files: (data && data.files) || [],
    excluded: (data && data.excluded) || []
  };
};
